module.exports = __webpack_public_path__ + "img/glacier-point-3.b6b3c85a.jpg";